import React from 'react';
import './Requirements.css';

const steps = [
  { n: '01', icon: 'fa-magnifying-glass', title: 'Choose Your Destination',       desc: 'Tell us where you want to travel and the purpose of your visit. We assess the right visa type for you.' },
  { n: '02', icon: 'fa-folder-open',      title: 'Prepare Your Documents',        desc: 'We provide a personalised document checklist and guide you through gathering everything needed.' },
  { n: '03', icon: 'fa-paper-plane',      title: 'Submit the Application',        desc: 'Our team fills, reviews, and submits your application with precision to avoid any rejections.' },
  { n: '04', icon: 'fa-circle-check',     title: 'Receive Assistance Throughout', desc: 'We track your application status, respond to embassy queries, and keep you updated at every stage.' },
];

export default function Requirements() {
  return (
    <section id="requirements" className="sec sec-alt">
      <div className="container">

        <div className="req-header">
          <p className="label"><i className="fas fa-route"></i> How It Works</p>
          <h2 className="sec-title">Simple 4-Step <span>Visa Process</span></h2>
          <div className="rule"></div>
          <p className="sec-body">We've simplified every step so you can focus on planning your trip, not paperwork.</p>
        </div>

        {/* Desktop: horizontal. Mobile: vertical */}
        <div className="tl-h-track">
          {steps.map((s, i) => (
            <div className="tl-h-step" key={i}>

              {/* Icon row (desktop: centres icon + draws connector; mobile: just the icon) */}
              <div className="tl-h-icon-row">
                <div className="tl-h-icon">
                  <i className={`fas ${s.icon}`}></i>
                </div>
                {/* Desktop connector — hidden on mobile via CSS */}
                {i < steps.length - 1 && <div className="tl-h-connector"></div>}
              </div>

              {/* Text */}
              <div className="tl-h-body">
                <span className="tl-h-num">Step {s.n}</span>
                <h4 className="tl-h-title">{s.title}</h4>
                <p className="tl-h-desc">{s.desc}</p>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
